import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './theme-provider';
import { queryClient } from './query-client';
import { AuthProvider } from '@/shared/auth/auth-provider';
import { ToastProvider } from '@/shared/ui/toast';
import { TooltipProvider } from '@/shared/ui/tooltip';

/**
 * Provider order matters.
 *
 * `QueryClientProvider` must wrap `AuthProvider`, because the auth provider
 * clears the query cache on sign-out. `ToastProvider` sits outside it so the
 * auth provider could raise a toast during boot if it ever needed to.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <TooltipProvider delayDuration={300}>
            <AuthProvider>{children}</AuthProvider>
          </TooltipProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
